import React from 'react';
import { readSummaryPrefs, SUMMARY_COLLAPSED_KEY } from '../utils/chartPrefs';

export type V2SummaryRow = {
  key: string;
  hands: string;
  winnings: string;
  winningsClass: string;
  bb100: string | number;
  vpip: string | number;
  pfr: string | number;
  wwsf: string | number;
};

type V2SummarySectionProps = {
  rows: V2SummaryRow[];
};

const V2SummarySection: React.FC<V2SummarySectionProps> = ({ rows }) => {
  const [collapsed, setCollapsed] = React.useState(() => readSummaryPrefs().collapsed);
  const detailsRef = React.useRef<HTMLDetailsElement>(null);

  React.useEffect(() => {
    try {
      localStorage.setItem(SUMMARY_COLLAPSED_KEY, collapsed ? '1' : '0');
    } catch {
      // ignore storage errors
    }
  }, [collapsed]);

  const handleToggle = (event: React.SyntheticEvent<HTMLDetailsElement>) => {
    setCollapsed(!event.currentTarget.open);
  };

  return (
    <details
      ref={detailsRef}
      className="chart-section summary-section-details"
      open={!collapsed}
      onToggle={handleToggle}
    >
      <summary className="chart-summary">
        <div>
          <h2>Summary</h2>
          <p className="chart-subtitle">
            По форматам и лимитам
            {collapsed ? <> · {rows.length ? `${rows.length} срезов` : 'нет данных'}</> : null}
          </p>
        </div>
      </summary>
      {rows.length === 0 ? (
        <p className="table-hint">Нет summary-данных для выбранных фильтров.</p>
      ) : (
        <div className="table-scroll" tabIndex={0} role="region" aria-label="Summary">
          <table className="history-table">
            <thead>
              <tr>
                {['Срез', 'Hands', 'Winnings', 'bb/100', 'VPIP', 'PFR', 'WWSF'].map((label) => (
                  <th key={label} scope="col">
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.key}>
                  <td>{row.key}</td>
                  <td>{row.hands}</td>
                  <td className={row.winningsClass}>{row.winnings}</td>
                  <td>{row.bb100}</td>
                  <td>{row.vpip}</td>
                  <td>{row.pfr}</td>
                  <td>{row.wwsf}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </details>
  );
};

export default V2SummarySection;
